import { NgModule } from '@angular/core'
import { DisplayNamePipe } from './display-name.pipe'

@NgModule({
    declarations: [DisplayNamePipe],
    exports: [DisplayNamePipe],
    providers: [DisplayNamePipe],
})
export class DisplayNamePipeModule {
}